import { render, staticRenderFns } from "./AreaEmbargadaParana.vue?vue&type=template&id=6feef1e7&scoped=true&lang=pug"
import script from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaParana.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaParana.vue?vue&type=style&index=0&id=6feef1e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feef1e7",
  null
  
)

export default component.exports